import React from 'react';
import {
  Box, Button, CircularProgress, DialogActions
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SaveIcon from '@mui/icons-material/Save';
import { useTranslation } from 'react-i18next';

const NodeEditorDialogActions = ({
  onDelete = null,
  onCancel,
  onSave,
  deleteDisabled = false,
  cancelDisabled = false,
  saveDisabled = false,
  saving = false,
  saveLabel = '',
}) => {
  const { t } = useTranslation();

  return (
    <DialogActions
      sx={{
        px: { xs: 1.5, sm: 3 },
        py: 2,
        gap: 1,
        justifyContent: 'space-between',
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box>
        {onDelete && (
          <Button
            onClick={onDelete}
            variant="outlined"
            color="error"
            disabled={deleteDisabled || saving}
            startIcon={<DeleteOutlineIcon />}
          >
            {t('common.delete', 'Delete')}
          </Button>
        )}
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          disabled={cancelDisabled || saving}
        >
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          disabled={saveDisabled || saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
        >
          {saving
            ? t('common.saving', 'Saving...')
            : saveLabel || t('common.save', 'Save')}
        </Button>
      </Box>
    </DialogActions>
  );
};

export default NodeEditorDialogActions;
